import { RegistrationFailureModel } from '../../models/registration_failure_model';
import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import { ISection } from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant, IFormattedSectionTime } from '../../../sections/servants/section_info_servant';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { ScheduledSectionTileServant } from '../../servants/scheduled_section_tile_servant';
import { ScheduledSectionStatus } from '../../types/scheduled_section_status_enum';
import { SectionStatusLabelStrategy } from '../../strategies/section_status_label_strategy';
import * as _4 from 'lodash4';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { ISectionSwapType } from '../../../../swap/interfaces/swap_section_interface';

class ScheduledSectionStatusLabel {
  private section: ISection & ISectionSwapType;
  private hideStatusLabel: boolean = false;
  constructor(
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngRegistrationFailureModel: RegistrationFailureModel,
    private ngSectionSwapServant: SectionSwapServant
  ) {}

  $onInit() {
    this.hideStatusLabel = _4.get(this.section, '_swap_type') === 'to' && this.ngSectionSwapServant.isInSwapMode();
  }

  getSectionStatusLabel() {
    const canAddFromWaitlist = this.ngScheduledSectionServant.canAddFromWaitlist(this.section);
    const hasStatus: boolean = this.ngScheduledSectionStatusServant.hasStatus(this.section);
    const isPending = this.ngScheduledSectionStatusServant.isStatusPending(this.section);
    const failedSectionDetails = this.ngRegistrationFailureModel.get(this.section.id);

    const status = this.section.status;
    const labelByStatus = SectionStatusLabelStrategy[status];
    const isValidFailureForCurrentStatus = this.ngScheduledSectionStatusServant.isValidFailureForCurrentStatus(
      this.section,
      _4.get(failedSectionDetails, 'type', '')
    );
    // Get Style
    const style = hasStatus ? `${labelByStatus.style} ${labelByStatus.marker_color}` : 'clr-gray_40-txt';
    // Get Text
    let text = hasStatus ? labelByStatus.text : 'Not Registered';
    // Get Icon
    let icon = '';
    // Failed
    if (failedSectionDetails && isValidFailureForCurrentStatus) {
      text = `${text}`;
      icon = `<i class="icon eab-icon-caution clr-red-txt"></i>`;
    } else if (isPending) {
      // Pending
      icon = `<i class="icon eab-icon-sync"></i>`;
    } else if (canAddFromWaitlist) {
      text = `${text}`;
    }
    return `${icon}${text}<span class="marker ${style}"></span>`;
  }
}

class ScheduledSectionStatusComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = ScheduledSectionStatusLabel;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_status_label/scheduled_section_status_label.html';
  }
}
angular.module('capability-ng-scheduler').component('scheduledSectionStatus', new ScheduledSectionStatusComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_status_label/scheduled_section_status_label.ts